/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_No_ValvesInputs */

const vi_irrigation_devices_no_valves = /** @type {(inputs: Irrigation_Devices_No_ValvesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa cấu hình van`)
};

/**

* @param {Irrigation_Devices_No_ValvesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_no_valves = /** @type {((inputs?: Irrigation_Devices_No_ValvesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_No_ValvesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_no_valves(inputs)
});